import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import InstallPrompt from "../components/InstallPrompt";
import routes from "./config";
import { Styles } from "../styles/styles";
import LoadingOverlay from "../common/LoadingOverlay";

// Import NotFound page
const NotFound = lazy(() => import("../pages/NotFound"));

const Router = () => {
  return (
    <Suspense fallback={<LoadingOverlay />}>
      <Styles />
      <Header />
      <InstallPrompt />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
        {/* Add a specific route for the 404 page */}
        <Route path="/404" component={NotFound} />
        {/* Add a catch-all route for 404 pages */}
        <Route component={NotFound} />
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
